import React, { useEffect, useState } from "react";

// ASSETS
import ArrowLeft from "assets/svg/ArrowDown.svg";

// STYLES
import {
  ActivityReportsContainer,
  ActivityReportsContentCardContainer,
  BackToGuidesButton,
  BackToGuidesImage,
  BackToWrapper,
  LeftSideContainer,
  RightSideContainer,
  TitleSectionWrapper,
  TitleWrapper,
  ReportsSectionReportCardWrapper,
  ReportsSectionReportCardTitleWrapper,
  ReportsSectionReportCardIconWrapper,
  ReportsSectionReportCardIcon,
} from "./QualityManagementStyled";

// LIBRARIES
import { useTranslation } from "react-i18next";

// MISC
import { IProps } from "./QualityManagementModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import aboutService from "services/aboutService";

// REDUX
import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";

const QualityManagement = (props: IProps) => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);
  const { t } = useTranslation();

  // STATE CONSTANTS
  const [documents, setDocuments] = useState<any>(null);

  // API REQUESTS

  useEffect(() => {
    aboutService
      .getQualityManagementDocuments([13, 14, 15, 16, 17, 18])
      .then((response) => {
        // console.log("getDocuments response", response);
        setDocuments(response);
      })
      .catch((err) => {
        console.log("getDocuments error", err);
      });
  }, []);

  // LIFE CYCLE
  const documentData =
    documents?.data.map((file: any) => {
      const pdfUrl = `${process.env.REACT_APP_UPLOAD_URL}${file?.attributes.attached_document.data.attributes.url}`;

      return {
        id: file?.id,
        title: file?.attributes.attached_document.data.attributes.name,
        pdfUrl: pdfUrl,
        handleDownload: async () => {
          try {
            const response = await fetch(pdfUrl, {
              headers: {},
            });
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            const blob = await response.blob();
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download =
              pdfUrl.split("/").pop() || "downloaded_document.pdf";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } catch (error) {
            console.error("Download error:", error);
          }
        },
      };
    }) || [];

  const reorderedDocumentData = [
    documentData[2],
    documentData[3],
    documentData[0],
    documentData[1],
    documentData[4],
    documentData[5],
  ];

  // EVENT HANDLERS

  return (
    <ActivityReportsContainer>
      <TitleSectionWrapper>
        <BackToWrapper
          onClick={() => window.history.back()}
          biggerCursor={biggerCursor}
        >
          <BackToGuidesImage src={ArrowLeft} alt="backIcon" />
          <BackToGuidesButton>
            <CustomText
              text={t("view.about.aboutDSU.button")}
              type={TextType.H5bold}
              color={COLORS.MetalicSilver}
            />
          </BackToGuidesButton>
        </BackToWrapper>
        <TitleWrapper>
          <CustomText
            type={TextType.H2}
            text={t("view.about.management.title")}
            color={COLORS.RaisinBlack}
          />
        </TitleWrapper>
      </TitleSectionWrapper>
      <LeftSideContainer>
        <ActivityReportsContentCardContainer>
          <CustomText
            text={t("view.about.management.description1")}
            type={TextType.P1}
            color={COLORS.Cultured}
          />
          <CustomText
            text={t("view.about.management.description2")}
            type={TextType.P1}
            color={COLORS.Cultured}
          />
          <CustomText
            text={t("view.about.management.description3")}
            type={TextType.P1}
            color={COLORS.Cultured}
          />
          <CustomText
            text={t("view.about.management.description4")}
            type={TextType.P1}
            color={COLORS.Cultured}
          />
          <CustomText
            text={t("view.about.management.description5")}
            type={TextType.P1}
            color={COLORS.Cultured}
          />
        </ActivityReportsContentCardContainer>
      </LeftSideContainer>
      <RightSideContainer>
        {reorderedDocumentData.map((document: any, index) => (
          <ReportsSectionReportCardWrapper
            key={index}
            onClick={document?.handleDownload}
            href={document?.pdfUrl}
            target="_blank"
          >
            <ReportsSectionReportCardTitleWrapper>
              <CustomText
                text={document?.title}
                type={TextType.H5}
                color={COLORS.RaisinBlack}
              />
            </ReportsSectionReportCardTitleWrapper>
            <ReportsSectionReportCardIconWrapper>
              <ReportsSectionReportCardIcon />
            </ReportsSectionReportCardIconWrapper>
          </ReportsSectionReportCardWrapper>
        ))}
      </RightSideContainer>
    </ActivityReportsContainer>
  );
};

export default QualityManagement;
